import React, { useEffect, useState, useRef } from 'react';
import './App.css';
import { LicenseInfo } from '@mui/x-license';
import { MomentCentral } from './Components/MomentCentral';
import { useAuth } from 'react-oidc-context';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import { MCProvider, useMCContext } from './Components/contexts/useMCStates';
import { EventPage } from './Components/EventPage';
import CreateApi from './Components/Settings/appSettings';
import { ThemeProvider } from '@mui/material/styles';
import { RegistrationSuccess } from './Components/RegistrationSuccess';
import { UserAccountSplash } from './Components/UserAccountSplash';
import { setAppTheme } from './Components/Settings/appTheme';
import { LoginPostHandler } from './Components/LoginPostHandler';
import { PublicRoute, ProtectedRoute } from './Components/AuthRouteWrappers';
import { StandingsEmbedPage } from './Components/StandingsEmbedPage';
import PullToRefresh from './Components/services/PullToRefresh';
import Sitemap from './Components/Sitemap';
import { useTokenManager } from '@moment-golf/auth';

if (process.env.REACT_APP_MUI_X_LICENSE_KEY) {
  LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_X_LICENSE_KEY);
}

function App() {

  const auth = useAuth();
  const api = CreateApi();
  //const navigate = useNavigate();
  const { setEventData, eventData, appTheme, factor, setFactor, setTheme, setWindowSize, windowSize } = useMCContext();
  const [initialAuthCheck, setInitialAuthCheck] = useState(true);
  const hasFetchedEvents = useRef(false);


  /* const handleResize = () => {
    const newWindowSize = {
      width: window.innerWidth,
      height: window.innerHeight,
      landscape: window.innerWidth > window.innerHeight,
      verticalMobile: window.innerWidth < window.innerHeight && window.innerWidth < 450,
      horizontalMobile: window.innerWidth < window.innerHeight && window.innerHeight < 450,
      verticalPC: window.innerWidth < window.innerHeight && window.innerWidth <= 600 ? "small" : 
          window.innerWidth < window.innerHeight && window.innerWidth <= 900 ? "medium" : 
          window.innerWidth < window.innerHeight ? "large" : "none",
      horizontalPC: window.innerWidth > window.innerHeight && window.innerWidth < 900 ? "small" : 
          window.innerWidth > window.innerHeight && window.innerWidth <= 1200 ? "medium" : 
          window.innerWidth > window.innerHeight ? "large" : "none",
      isMobile: /Mobi|Android|iPhone|iPad|iPod|tablet|Tab/i.test(navigator.userAgent),
      appBarHeight: document.getElementById('moment-central-header-ab')?.clientHeight || 80
    }

    setWindowSize((prev: any) => ({ ...prev, ...newWindowSize }));
};

  useEffect(() => {

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
        window.removeEventListener('resize', handleResize);
    };
}, []); */

  useTokenManager(auth);

  useEffect(() => {
    // Only attempt silent auth once when the app loads
    // Don't retry on every route change
    if (!auth.isLoading && !auth.isAuthenticated) {
      auth.signinSilent()
        .then(() => {
          console.log('Silent authentication successful');
          setInitialAuthCheck(false);
        })
        .catch(() => {
          console.log('Silent authentication failed - user browsing as guest');
          setInitialAuthCheck(false);
          // Don't redirect, just let them browse
        });
    }

    if (windowSize.isMobile) {
      setFactor(1);
      setTheme(setAppTheme(1));
    } else {
      setFactor(1);
      setTheme(setAppTheme(1));
    }
  }, []); // Empty dependency array - only run once on mount

  const getPublicEvents = async () => {
    try {
      console.log('Fetching public events...');
      const events = await api.get('/mc/GetPublicEvents');
      console.log('Public events fetched successfully:', events.data.length, 'events');
      setEventData(events.data);
    } catch (error) {
      console.error('Error fetching public events:', error);
    }
  }

  useEffect(() => {
    // Only fetch events once when the app loads
    if (!hasFetchedEvents.current) {
      hasFetchedEvents.current = true;
      getPublicEvents();
    }
  }, []); // Empty dependency array - only run once on mount

  return (
    <div className="App" style={{ 
      height: '100%',
      width: '100%',
      // Avoid 100dvw/dvh — viewport units overflow parent iframes (same as leaderboard embed)
      overflow: 'hidden',
      position: 'relative',
      paddingBottom: windowSize.verticalMobile ? 'env(safe-area-inset-bottom)' : '0',
      paddingTop: windowSize.horizontalMobile ? 'env(safe-area-inset-top)' : '0',
      WebkitOverflowScrolling: 'touch',
      overscrollBehavior: 'none'
    }}>
      <ThemeProvider theme={appTheme}>
        <Router>
          <Routes>
            <Route path="/" element={
              <PublicRoute>
                <MomentCentral />
              </PublicRoute>
            } />
            <Route path="/events/:eventId" element={
              <PublicRoute>
                <EventPage />
              </PublicRoute>
            } />
            <Route path="/registration/success" element={
              <PublicRoute>
                <RegistrationSuccess />
              </PublicRoute>
            } />
            <Route 
              path="/login/handler" 
              element={<LoginPostHandler />} 
            />
            <Route path="/myAccount" element={
              <ProtectedRoute>
                <UserAccountSplash />
              </ProtectedRoute>
            } />
            <Route path="/standings" element={
              <PublicRoute>
                <StandingsEmbedPage />
              </PublicRoute>
            } />
            <Route path="/site/workflow/gsc/sitemap.xml" element={<Sitemap />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
